<mat-tab-group animationDuration="1000ms" (selectedTabChange)="onTabChanged($event)">
    <mat-tab label="Published">
        <div class="col-md-12 mt-3" *ngIf="resourceDataSource && resourceDataSource.data.length >0">
            <mat-form-field class="float-right">
                <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter">
            </mat-form-field>

            <div class="row">
                <div class="col-md-12 mt-2">
                    <div class="row" *ngIf="success.length > 0" class="padding-b-15">
                        <div class="alert alert-success">
                            <button type="button" class="close" data-dismiss="alert" (click)=closeSuccess()>×</button>
                            <span>The following Support Topic(s) were succesfully moved to Draft.</span>
                            <ul>
                                <li *ngFor="let feature of success">{{feature}}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Material Table -->
            <table aria-describedby="publish-feature" aria-labelledby="publish-feature" mat-table [dataSource]="resourceDataSource" matSort
                class="col-md-12 publish-table mat-elevation-z8">
                <ng-container matColumnDef="select">
                    <th id="publish-select" class="resource-header-card" mat-header-cell *matHeaderCellDef>
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <mat-checkbox class="pl-checkbox" (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(element) : null"
                            [checked]="selection.isSelected(element)">
                        </mat-checkbox>
                    </td>
                </ng-container>

                <ng-container matColumnDef="controls.featureName">
                    <th id="publish-SP" class="resource-header-card" mat-header-cell *matHeaderCellDef mat-sort-header> Support Topics </th>
                    <td mat-cell *matCellDef="let element" (click)="navigateToSupportTopic(element)" class="text-decoration-line action-control-delete cursor-pointer">
                        {{element.controls[0].featureName}} </td>
                </ng-container>

                <ng-container matColumnDef="featureType">
                    <th id="publish-type" class="resource-header-card" mat-header-cell *matHeaderCellDef mat-sort-header> Support Topics Type </th>
                    <td mat-cell *matCellDef="let element"> {{element.featureType | capitalizeStr}} </td>
                </ng-container>

                <ng-container matColumnDef="lastModifiedBy">
                    <th id="publish-modified-by" class="resource-header-card" mat-header-cell *matHeaderCellDef mat-sort-header> Last Modified By </th>
                    <td mat-cell *matCellDef="let element"> {{element.lastModifiedBy ? element.lastModifiedBy : 'System'}} </td>
                </ng-container>

                <ng-container matColumnDef="lastModifiedDate">
                    <th id="publish-modified-date" class="resource-header-card" mat-header-cell *matHeaderCellDef mat-sort-header> {{ "Label.lastUpdatedDate" | translate}} </th>
                    <td mat-cell *matCellDef="let element"> {{element.lastModifiedDate | date:'short'}} </td>
                </ng-container>

                <ng-container matColumnDef="publishedDate">
                    <th id="publish-date" class="resource-header-card" mat-header-cell *matHeaderCellDef mat-sort-header> {{ "Label.publishedDate" | translate}} </th>
                    <td mat-cell *matCellDef="let element"> {{element.publishedDate | date:'short'}} </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>


            <mat-paginator [pageSizeOptions]="[5,10,20]" showFirstLastButtons></mat-paginator>
            <div class="publish-action-controls">
                <span>
                    <button [disabled]="this.selection.selected.length < 1" class="ml-2 btn btn-browse" (click)="previewFeature()" type="button">Preview</button>
                </span>
                <span *ngIf="hasPermission">
                    <button [disabled]="this.selection.selected.length < 1" class="ml-2 btn btn-browse" (click)="moveToDraft()" type="button">Move To Draft</button>
                </span>
            </div>
        </div>

    </mat-tab>
    <mat-tab label="Draft">
        <app-draft-feature *ngIf="isDraft"></app-draft-feature>
    </mat-tab>
</mat-tab-group>